import React, { ReactNode, ComponentType, Component } from 'react';
import styled from '@emotion/styled';
import { SideNavConsumer } from '../../context/SideNavContext';
import { SubNavEnum } from '../../context/models/SubNavEnum';
import SubNavToggle from './SubNavToggle';
import HoverLabel from '../HoverLabel';

const Container = styled.a`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 1rem 0.75rem;
  border-bottom: 1px solid #5ca0d3;
  text-decoration: none;
  color: #c8dff0;

  svg {
    width: 24px;
    max-width: 24px;
    max-height: 19px;

    path {
      fill: #c8dff0;
    }
  }

  :hover {
    background-color: #57a8e6;
    color: #ffffff;

    svg {
      path {
        fill: #ffffff;
      }
    }
  }
`;

const Constrainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  width: 100%;
  justify-content: space-between;
`;

const HiddenInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const IconWrapper = styled.div`
  display: block;
  margin-right: 1rem;

  svg {
    width: 24px;
    max-width: 24px;
    max-height: 19px;

    path {
      fill: #c8dff0;
    }
  }
`;

const Text = styled.span`
  white-space: nowrap;
  overflow: hidden;
  user-select: none;
  padding: 0.05rem 0;
`;

const SubNavList = styled.section<{ visible: boolean }>`
  flex-direction: column;
  background: #4694ce;
  color: white;
  height: 100%;
  width: 100%;
  overflow: hidden;

  border-bottom: ${s => (s.visible ? '1px solid #5ca0d3' : '')};
  max-height: ${s => (s.visible ? '20rem' : '0rem')};
  will-change: max-height;
  transition: max-height 250ms ease;
`;

interface Props {
  children: ReactNode;
  text: string;
  icon: ComponentType;
  type: SubNavEnum;
}

class SubNavPanel extends Component<Props> {
  state = {
    hover: false,
  };

  // Icon is passed as prop so needs Shape definition
  SubNavIcon: ComponentType = this.props.icon;

  handleMouseEnter = () => this.setState({ hover: true });
  handleMouseLeave = () => this.setState({ hover: false });

  render() {
    return (
      <SideNavConsumer>
        {({ state, setOpenSubNav }) => (
          <>
            <Container
              data-testid="sub-nav-panel-container"
              // TODO: This will rerender every time you hover,
              // even if the nav is open. Needs better fix.
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              onClick={() => {
                setOpenSubNav(this.props.type);
              }}
            >
              <Constrainer>
                <HiddenInner>
                  <IconWrapper>
                    <this.SubNavIcon />
                  </IconWrapper>
                  <Text>{this.props.text}</Text>
                </HiddenInner>
                <SubNavToggle open={state.openSubNav === this.props.type} />
              </Constrainer>
              <HoverLabel text={this.props.text} active={this.state.hover} isParent={true} />
            </Container>

            <SubNavList
              data-testid="sub-nav-list"
              visible={state.isSideNavOpen && state.openSubNav === this.props.type}
            >
              {this.props.children}
            </SubNavList>
          </>
        )}
      </SideNavConsumer>
    );
  }
}

export default SubNavPanel;
export { SubNavPanel };
